import React from 'react';

const KrishnaHeroVideo: React.FC = () => {
  return (
    <video
      src={"/waiting flute animation.mp4"}
      autoPlay
      loop
      muted
      playsInline
      preload="auto"
      aria-hidden="true"
      style={{
        position: 'absolute',
        top: 35,
        left: 65,
        zIndex: 10,
        display: 'block',
        clipPath: 'inset(0px 2px 2px 0px)',
        transform: 'translateZ(0)',
        backfaceVisibility: 'hidden',
        WebkitMaskImage: 'linear-gradient(to right, black 0%, black calc(100% - 3px), transparent 100%)',
        maskImage: 'linear-gradient(to right, black 0%, black calc(100% - 3px), transparent 100%)',
        // No width/height set: render at intrinsic (default) resolution
      }}
    />
  );
};

export default KrishnaHeroVideo;